import AuthGuard from '@components/AuthGuard';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import SearchLine from '@icons/SearchLine';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import styles from './styles.module.scss';
import { queryAtom, isMyShopAtom } from '../../atoms/shopsInMapAtoms';

function ShopFilter() {
  const [isMy, setIsMy] = useAtom(isMyShopAtom);
  const [query, setQuery] = useAtom(queryAtom);
  const showHelperText = query !== undefined && query.length === 1;
  useEffect(() => {
    setQuery('');
  }, []);
  return (
        <Column as='section'
                fullWidth
                spacing={16}
                className={styles.container}>
            <Row justify='space-between' fullWidth>
                <TextUnderline>
                    <Text size='lg'>
                        찾으시는 매장을 검색해보세요
                    </Text>
                </TextUnderline>
                <Row spacing={16}>
                    <Text
                          color={colors.gray7}
                          onClick={() => setIsMy(false)}
                          fontWeight={isMy ? 'regular' : 'bold'}>
                        전체
                    </Text>
                    <AuthGuard>
                        <Text
                            color={colors.gray7}
                            onClick={() => setIsMy(true)}
                            fontWeight={isMy ? 'bold' : 'regular'}>
                            MY매장
                        </Text>
                    </AuthGuard>
                </Row>
            </Row>
            <TextField placeholder='매장명을 입력해주세요'
                       maxLength={20}
                       onChange={(e) => setQuery(e.target.value)}
                       helperText={showHelperText ? '검색어는 2자 이상 입력해주세요.' : ''}
                       trailing={<SearchLine style={{ marginRight: 12 }}/>} />
        </Column>
  );
}

export default ShopFilter;
